import { render } from "./OpportunityCard.vue?vue&type=template&id=7b69c9fb&scoped=true"
import script from "./OpportunityCard.vue?vue&type=script&lang=js"
export * from "./OpportunityCard.vue?vue&type=script&lang=js"

import "./OpportunityCard.vue?vue&type=style&index=0&id=7b69c9fb&lang=scss&scoped=true"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7b69c9fb"]])

export default __exports__